// extracted by mini-css-extract-plugin
export default {"wrapper":"DeliveryItem_wrapper__KoE5R","input-row":"DeliveryItem_input-row__lZMhf","input-field-group":"DeliveryItem_input-field-group__VU7Mi"};